// hooks/useRedirect.ts
import { useNavigate } from "react-router-dom";

export const useRedirect = () => {
  const navigate = useNavigate();

  return (path: string, replace = false) => {
    navigate(path, { replace });
  };
};
